module.exports = __webpack_public_path__ + "2a3b940a36a9abb5ed8b56c0cd7922b9.svg";